/* ===== CaloShop calo-gift-mask.js v3.3 (2026-08-18) =====
 * NEU gegenueber v2: Der Kunde darf den Gratis-Shaker abwaehlen.
 *   v2 legte ihn per ensureGift() bei JEDEM /cart-Request zwingend zurueck.
 *   Stammkunden, die beim 2./3. Sparpaket keinen weiteren Shaker wollten,
 *   konnten ihn dadurch nicht entfernen (live reproduziert 18.08.2026).
 *   Jetzt: Abwahl wird gemerkt (localStorage) und dauerhaft respektiert,
 *   ein Rueckhol-Link im Warenkorb macht sie reversibel.
 * Der Bundle-Rabatt haengt an der Beutel-Menge, NICHT am Shaker -
 *   das Entfernen kostet den Kunden keinen Rabatt (live verifiziert:
 *   6 x 4,49 EUR = 26,94 EUR blieb ohne Shaker bei 22,92 EUR).
 * Unveraendert: optische Sofort-Maske (Preis 0,00 EUR + Summenkorrektur).
 */
(function () {
  'use strict';

  var GRATIS_VARIANT  = '57641687875915';
  var GIFT_MIN_ITEMS  = 6;
  var OPTOUT_KEY      = 'calo_gift_optout';
  var GIFT_BADGE_TEXT = 'Gratis-Geschenk';
  var ROW_SELECTOR    = 'tr.cart-item, .cart-item, .cart-drawer-item';

  /* ---------- Abwahl-Speicher ---------- */
  function optedOut() {
    try { return localStorage.getItem(OPTOUT_KEY) === '1'; } catch (e) { return false; }
  }
  function setOptOut(on) {
    try {
      if (on) { localStorage.setItem(OPTOUT_KEY, '1'); }
      else { localStorage.removeItem(OPTOUT_KEY); }
    } catch (e) {}
  }

  /* ---------- Geldformate (unveraendert aus v2) ---------- */
  function parseMoneyToCents(str) {
    if (!str) return null;
    var m = str.match(/(\d{1,3}(?:[.\s]\d{3})*|\d+)[.,](\d{2})(?!\d)/);
    if (!m) return null;
    var intpart = m[1].replace(/[.\s]/g, '');
    return { cents: parseInt(intpart, 10) * 100 + parseInt(m[2], 10), match: m[0] };
  }
  function formatCentsDe(cents) {
    var neg = cents < 0;
    cents = Math.abs(cents);
    var euros = Math.floor(cents / 100), c = cents % 100;
    var eurStr = euros.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (neg ? '-' : '') + eurStr + ',' + (c < 10 ? '0' + c : c);
  }
  function isFlagged(item) {
    var p = item.properties || {};
    return p._free_gift === 'true' || p._free_gift === true;
  }

  /* ---------- Warenkorb-Abgleich ---------- */
  var _busy = false;
  /* Nach einem echten X-Klick auf die Gratis-Zeile loescht das Theme selbst
   * (Dawn CartRemoveButton arbeitet mit ZEILENNUMMERN: updateQuantity(index,0)).
   * Loescht unser Cleanup zeitgleich per Schluessel, verrutschen die Zeilen und
   * der Theme-Request trifft die Beutel-Zeile -> Warenkorb leer (live passiert,
   * 18.08.26, sporadisch je nach Request-Reihenfolge). Deshalb pausiert das
   * Cleanup nach dem Klick und ueberlaesst dem Theme das Entfernen. */
  var _cleanupPauseUntil = 0;

  function syncGift() {
    if (_busy) return;
    _busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var giftItem = null, realCount = 0;
        cart.items.forEach(function (it) {
          if (String(it.variant_id) === GRATIS_VARIANT || isFlagged(it)) { giftItem = it; }
          else { realCount += it.quantity; }
        });
        var hasGift   = !!giftItem;
        var qualifies = realCount >= GIFT_MIN_ITEMS;

        /* KEIN Zustandsvergleich als Abwahl-Erkennung!
         * Frueher (v3/v3.1) galt "Shaker war da, ist weg, Anspruch besteht
         * weiter" als Kundenabwahl. Das ist nachweislich untauglich:
         *  - Das Bundle-Widget legt die Beutel UND den BEZAHLTEN Shaker
         *    (57113737199947, als Geschenk markiert) in den Warenkorb.
         *  - Der Cart Security Guard in theme.liquid entfernt diese Zeile
         *    daraufhin und ersetzt sie durch die 0-EUR-Variante.
         * Genau dieser Tausch sieht wie eine Abwahl aus (Shaker weg,
         * Beutelmenge unveraendert) und setzte je nach Timing sporadisch das
         * Abwahl-Flag -> Kunden verloren den Shaker ungewollt.
         * Abwahl wird deshalb NUR noch durch den echten Klick gesetzt. */

        /* (2) Abgewaehlt, liegt aber drin (GemPages-/Funnel-Button legt ihn
         *     direkt in den Warenkorb) -> wieder entfernen. */
        if (optedOut() && hasGift) {
          if (Date.now() < _cleanupPauseUntil) { _busy = false; return; }
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: giftItem.key, quantity: 0 })
          }).then(afterCartWrite).catch(function () { _busy = false; });
        }

        /* (3) Nicht abgewaehlt und Anspruch besteht -> Gift ergaenzen. */
        if (!optedOut() && !hasGift && qualifies) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: Number(GRATIS_VARIANT), quantity: 1, properties: { _free_gift: 'true' }
            })
          }).then(afterCartWrite).catch(function () { _busy = false; });
        }

        _busy = false;
        renderReoptIn(optedOut() && qualifies && !hasGift);
      })
      .catch(function () { _busy = false; });
  }

  function afterCartWrite() {
    _busy = false;
    if (window.location.pathname === '/cart') { window.location.reload(); }
    else { document.dispatchEvent(new CustomEvent('cart:refresh')); }
  }

  /* ---------- Abwahl erkennen: EINZIGER Ausloeser ist der echte Klick ----------
   * Zwei unabhaengige Merkmale, damit die Erkennung nicht an einer einzelnen
   * DOM-Eigenheit haengt: die Gratis-Variante im Entfernen-Link ODER das
   * "Gratis-Geschenk"-Kennzeichen in der Warenkorbzeile. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('cart-remove-button, .cart-remove-button, a[href*="quantity=0"]');
    if (!btn) return;
    var link = btn.tagName === 'A' ? btn : btn.querySelector('a[href]');
    var href = link ? (link.getAttribute('href') || '') : '';
    var row  = btn.closest(ROW_SELECTOR);
    var istGift = href.indexOf(GRATIS_VARIANT) !== -1
               || (row && row.textContent && row.textContent.indexOf(GIFT_BADGE_TEXT) !== -1);
    if (istGift) {
      setOptOut(true);
      _cleanupPauseUntil = Date.now() + 8000; // Theme loescht selbst; Cleanup haelt sich raus
    }
  }, true);

  /* ---------- Rueckhol-Link ---------- */
  function renderReoptIn(show) {
    var existing = document.getElementById('calo-gift-reoptin');
    if (!show) { if (existing) { existing.remove(); } return; }
    if (existing) return;
    var host = document.querySelector('#main-cart-items')
            || document.querySelector('.cart-drawer__footer')
            || document.querySelector('#CartDrawer .drawer__inner');
    if (!host) return;
    var box = document.createElement('div');
    box.id = 'calo-gift-reoptin';
    box.style.cssText = 'margin:12px 0;padding:10px 14px;border:1px dashed #00AB92;'
                      + 'border-radius:10px;font-size:14px;line-height:1.4;color:#121212;';
    box.innerHTML = '<span>Du hast den Gratis-Shaker entfernt.</span> '
                  + '<a href="#" id="calo-gift-reoptin-link" style="color:#00AB92;font-weight:700;'
                  + 'text-decoration:underline;cursor:pointer">Doch dazulegen</a>';
    host.appendChild(box);
    box.querySelector('#calo-gift-reoptin-link').addEventListener('click', function (ev) {
      ev.preventDefault();
      setOptOut(false);

      syncGift();
    });
  }

  /* ---------- Optische Sofort-Maske (unveraendert aus v2) ---------- */
  var _maskBusy = false;
  function instantGiftMask() {
    if (_maskBusy) return;
    _maskBusy = true;
    try {
      var rows = document.querySelectorAll('tr.cart-item, .cart-item'), removedCents = 0;
      rows.forEach(function (row) {
        if (!row.textContent || row.textContent.indexOf(GIFT_BADGE_TEXT) === -1) return;
        var wrap = row.querySelector('.cart-item__price-wrapper');
        if (wrap) {
          var spans = wrap.querySelectorAll('span');
          var target = spans.length ? spans[spans.length - 1] : null;
          if (target) {
            var pm = parseMoneyToCents(target.textContent);
            if (pm && pm.cents > 0) { removedCents += pm.cents; }
          }
        }
        var priceEls = row.querySelectorAll('.cart-item__price-wrapper span, .cart-item__price-wrapper s, .cart-item__final-price, .cart-item__old-price, .price, .product-option');
        priceEls.forEach(function (el) {
          var p = parseMoneyToCents(el.textContent);
          if (p && p.cents > 0) { el.textContent = '0,00 €'; el.style.color = '#00a09a'; }
        });
      });
      if (removedCents > 0) {
        document.querySelectorAll('.totals__total-value').forEach(function (tot) {
          var pm = parseMoneyToCents(tot.textContent);
          if (!pm) return;
          var newCents = pm.cents - removedCents;
          if (newCents < 0) { newCents = 0; }
          tot.textContent = tot.textContent.replace(pm.match, formatCentsDe(newCents));
        });
      }
    } catch (e) {}
    _maskBusy = false;
  }

  var _maskScheduled = false;
  function scheduleMask() {
    if (_maskScheduled) return;
    _maskScheduled = true;
    var run = function () { _maskScheduled = false; instantGiftMask(); };
    if (window.requestAnimationFrame) { window.requestAnimationFrame(run); } else { setTimeout(run, 16); }
  }
  function attachObserver() {
    ['#CartDrawer', '#main-cart-items', '#main-cart-footer'].forEach(function (sel) {
      var node = document.querySelector(sel);
      if (node) {
        new MutationObserver(scheduleMask).observe(node, { childList: true, subtree: true, characterData: true });
      }
    });
  }

  function init() { instantGiftMask(); attachObserver(); syncGift(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  ['cart:refresh', 'cart:updated'].forEach(function (evt) {
    document.addEventListener(evt, function () { instantGiftMask(); syncGift(); });
  });

  var _origFetch = window.fetch;
  window.fetch = function (url, options) {
    var result = _origFetch.apply(this, arguments);
    // 06.09.26: nur Warenkorb-MUTATIONEN – das eigene GET /cart.js (syncGift) loeste sonst eine Endlosschleife aus
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url) && result && result.then) {
      result.then(function () { setTimeout(function () { scheduleMask(); syncGift(); }, 80); });
    }
    return result;
  };
})();
